import { CommonModule } from "@angular/common";
import { Component, computed, Inject, inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { environment } from "@env/environment";
import { OrderActionBase } from "@features/order-actions/models/order-action.model";
import { OrderSummary } from "@features/orders/models/order.model";
import { TenantUrlUtilService } from "@shared/services/tenant-url-util.service";
import moment from "moment";

@Component({
  selector: "app-create-ticket-dialog",
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule],
  templateUrl: "./create-ticket-dialog.component.html",
  styleUrl: "./create-ticket-dialog.component.scss",
})
export class CreateTicketDialogComponent {
  dialogRef = inject(MatDialogRef<CreateTicketDialogComponent>);
  tenantUrlUtilService = inject(TenantUrlUtilService);

  constructor(@Inject(MAT_DIALOG_DATA) public order: OrderActionBase) {}

  readonly searchValue = this.tenantUrlUtilService.documentValue;
  readonly tenantId = this.tenantUrlUtilService.currentTenant;
  readonly daterange = this.tenantUrlUtilService.dateRange;
  readonly parsedDates = computed(() => {
    const range = this.daterange();
    if (!range) return { dateFrom: null, dateTo: null };
    return {
      dateFrom: moment(range.dateFrom, "DD/MM/YYYY").valueOf(),
      dateTo: moment(range.dateTo, "DD/MM/YYYY").valueOf(),
    };
  });

  getAriaUrl(): string {
    console.log("order", this.order);
    // return `${environment.BASE_ARIA}/search?tenantIds=${this.}&searchValue=${this.searchValue()}&dateFrom=${this.parsedDates().dateFrom}&dateTo=${this.parsedDates().dateTo}`;
    return `${environment.BASE_ARIA}/new-ticket/INCIDENCE/${this.tenantId()}/${this.order.orderId}/${this.order.orderType}/`;
  }

  getRexUrl(): string {
    return `${environment.BASE_REX}/new-request/wizard/CD?tenantIds=${this.tenantId()}&searchValue=${this.searchValue()}&dateFrom=${this.parsedDates().dateFrom}&dateTo=${this.parsedDates().dateTo}`;
  }
}
